import React from 'react';

export default function ValidationError({ message }) {
    if (!message) {
        return null;
    }

    return <p className="mt-1 text-sm text-[#dc3939]">{message}</p>;
}
